<template>
  <div class="pb-16 lg:pb-0">
    <template
      v-for="(block, index) in headerBlocks"
      :key="'header-' + index"
    >
      <SafeBlockRenderer :block="block" />
    </template>

    <template
      v-for="(block, index) in midLayoutBlocks"
      :key="'mid-' + index"
    >
      <SafeBlockRenderer :block="block" />
    </template>

    <slot />

    <template
      v-for="(block, index) in footerBlocks"
      :key="'footer-' + index"
    >
      <SafeBlockRenderer :block="block" />
    </template>
    <PatientSiteTabBar />
  </div>
</template>

<script setup lang="ts">
import SafeBlockRenderer from '~/components/SafeBlockRenderer.vue'

const {
  headerBlocks,
  midLayoutBlocks,
  footerBlocks,
} = usePageBlocks()
</script>
